import { ButtonProps } from "@mui/material";
import FlowBackButton from "./FlowBackButton";
import { useStylesCss } from "./AppButtons.styles";

const TextBackButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...props.sx, ...classes.general };
  const myProps = {
    sx: myClasses,
    ...props,
  };
  return (
    <FlowBackButton {...myProps} disableElevation={true} size="small">
      {props.children}
    </FlowBackButton>
  );
};
export default TextBackButton;
